import { Title, TitleSection, Wrapper } from "../Properties/Details/styles";
import RatingCategories from "./RatingCategories";

export default function RatingResource() {
  return (
    <Wrapper>
      <TitleSection>
        <Title> Rating Resource Management </Title>
      </TitleSection>
      <RatingCategories />
    </Wrapper>
  );
}
